import { useClickOutside } from '@/app/hooks/useClickOutside'
import * as React from 'react'

const SearchInput = ({
  search,
  setSearch,
  searchResults,
  placeholder = 'Szukaj kierowcy...',
  id = 'search-driver-input',
  handleClickOutside = () => {},
  inline = false,
}: { 
  search: string
  setSearch: React.Dispatch<string>
  searchResults: number
  placeholder?: string
  id?: string
  handleClickOutside?: () => void
  // Renders the field in the normal document flow instead of a floating popup.
  inline?: boolean
}) => {
  const ref = React.useRef(null)
  // An inline field lives in the layout, so it must not close on an outside click.
  const noop = React.useCallback(() => {}, [])
  useClickOutside({ ref, handler: inline ? noop : handleClickOutside })

  return (
    <div
      ref={ref}
      className={
        inline
          ? 'tw-w-full tw-bg-white tw-p-2'
          : 'tw-absolute tw-z-[300] tw-mt-2 tw-w-[320px] tw-rounded-lg tw-bg-white tw-p-2 tw-shadow-md'
      }
    >
      <div className="tw-relative tw-w-full">
        <input
          id={id}
          autoFocus
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder={placeholder}
          className="tw-w-full tw-rounded tw-border tw-border-neutral-300 tw-px-3 tw-py-2 tw-text-sm focus:tw-outline-none"
          onClick={(e) => e.stopPropagation()}
        />

        <div className="tw-absolute tw-right-2 tw-top-1/2 tw-flex tw--translate-y-1/2 tw-items-center tw-gap-2">
          {search && (
            <>
              <span className="tw-text-sm tw-text-gray-500">
                {searchResults}
              </span>
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation()
                  setSearch('')
                  if(handleClickOutside) handleClickOutside()
                }}
                className="tw-text-gray-400 hover:tw-text-gray-700"
              >
                ✕
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default SearchInput
